import { Box } from '@chakra-ui/react';
import { FC, PropsWithChildren } from 'react';
import { headerHeight } from './Header/Header';
import { navbarHeight } from './NavBar';

export const sidebarWidth = 250;

const SidebarLayout: FC<PropsWithChildren> = ({ children }) => {
  return (
    <Box
      position="sticky"
      top="0"
      minW={`${sidebarWidth}px`}
      w={`${sidebarWidth}px`}
      mr="20px"
      height="auto"
      maxH={`calc(100vh - ${headerHeight + navbarHeight + 40}px)`}
      overflow="auto"
    >
      {children}
    </Box>
  );
};

export default SidebarLayout;
